"use client";

import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from "react";

type InitialDiscountState = {
  code: string | null;
  isHydrated: boolean;
};

const InitialDiscountStateContext = createContext<InitialDiscountState>({
  code: null,
  isHydrated: true,
});
const SetInitialDiscountStateContext = createContext<Dispatch<
  SetStateAction<InitialDiscountState>
> | null>(null);

export function InitialDiscountProvider({
  initialDiscountCode,
  initialHydrated = true,
  children,
}: {
  initialDiscountCode: string | null;
  initialHydrated?: boolean;
  children: ReactNode;
}) {
  const [state, setState] = useState<InitialDiscountState>({
    code: initialDiscountCode,
    isHydrated: initialHydrated,
  });

  return (
    <SetInitialDiscountStateContext.Provider value={setState}>
      <InitialDiscountStateContext.Provider value={state}>
        {children}
      </InitialDiscountStateContext.Provider>
    </SetInitialDiscountStateContext.Provider>
  );
}

export function useInitialDiscountCode() {
  return useContext(InitialDiscountStateContext).code;
}

export function useIsInitialDiscountHydrated() {
  return useContext(InitialDiscountStateContext).isHydrated;
}

export function useSetInitialDiscountState() {
  const setInitialDiscountState = useContext(SetInitialDiscountStateContext);

  if (!setInitialDiscountState) {
    throw new Error(
      "useSetInitialDiscountState must be used within InitialDiscountProvider",
    );
  }

  return setInitialDiscountState;
}
